import React from "react";
import SimpleFileInput from "./SimpleFileInput";
import { Say } from "../../../languages";

type Props = {
  visible: boolean;
  children: React.ReactNode;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handlePhotoAccept: (event: React.MouseEvent<HTMLButtonElement>) => void;
  photoType: string;
};

const PhotoReview = ({
  visible,
  children,
  handleFileChange,
  handlePhotoAccept,
  photoType
}: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="photo-moderation__photo-review">
      {children}

      <p className="photo-moderation__confirmation-text">
        <Say phrase="photo_step.photo_suggestion_heading" />
      </p>
      <div className="photo-moderation__photo-review-buttons">
        <button className="btn btn-primary" onClick={handlePhotoAccept}>
          <Say phrase="photo_step.photo_suggestion_cta_confirm" />
        </button>
        <SimpleFileInput
          handleFileChange={handleFileChange}
          labelPhraseKey="photo_step.photo_retake_cta"
          inputId="photo_retake"
          visible={photoType !== "booth"}
        />
      </div>
    </div>
  );
};

export default PhotoReview;
